import React, { useState, useEffect, useMemo, Suspense } from 'react';
import { connect } from 'react-redux';
import Loader from '../common/Loader/newLoaderModal';
const FullWithModal = React.lazy(() => import( '../common/Modal/FullWidthModal'));
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import cn from 'classnames';
import styles from './checksCommon.module.scss';
import { TouchableDiv } from '../common/Touchable/index';

const ConfirmationPop = (props) => {

  // Props Destructuring
  const { isOpen, onClose, pendingActionType,auth, menuItemsHashTable,allMenusHashTable, serverAppTheme } = props;
  // State Management
  const [selectedSeats, setSelectedSeats] = useState([]);


// inside your component
const filteredPendingItems = useMemo(() => {
  const newArr = [];

  if (pendingActionType.type === 'send all' || pendingActionType.type === 'sendAll') {
    const cart = pendingActionType?.data?.PendingItems || [];

    for (const element of cart) {
      const groupItem = allMenusHashTable?.find(item => item.id === element?.menuScreenId);

      if (
        groupItem?.orderTypePrintRouting === true ||
        menuItemsHashTable[element.menuItemId]?.orderTypePrintRouting === true
      ) {
        newArr.push(element);
      }
    }
  } else if (pendingActionType.type === 'send selected' || pendingActionType.type === 'sendSelect') {
    const cart = pendingActionType?.data?.selectedItem || [];

    for (const element of cart) {
      const groupItem = allMenusHashTable?.find(item => item.id === element?.menuScreenId);

      if (
        groupItem?.orderTypePrintRouting === true ||
      menuItemsHashTable[element.menuItemId]?.orderTypePrintRouting === true
      ) {
        newArr.push(element);
      }
    }
  }

  return newArr;
}, [pendingActionType, menuItemsHashTable, allMenusHashTable]);

  // React Hooks
  useEffect(()=> {
    setSelectedSeats(filteredPendingItems)
  }, [filteredPendingItems])

  // HTML CSS CODE
  return (
    <Suspense fallback={<Loader />}>
    <FullWithModal
     isOpen={isOpen}
     isModalCenter
     style={{background:props.serverAppTheme.popUp_bg, border: props.serverAppTheme?.popupBorder, borderRadius:"16px", boxShadow: props.serverAppTheme?.popUp_box_shadow, height:'100%', margin:'auto', width:'100%'}}
     customClass='h-100 w-100'  customClass2='h-100 w-100 p-3'
     noBackground
    >

<div className='col-12 p-0 h-100 position-relative' style={{color: serverAppTheme?.primary_text}}>
      <TouchableDiv 
        className="text-right position-absolute" 
        style={{color:props.serverAppTheme?.iconcolor, zIndex:'999', right:'10px', top:'14px'}}
        tabIndex="0" 
        role="button"
          onClick={(e) => { onClose('no'); e.preventDefault(); }}
      >
       <Cross fill={props.serverAppTheme?.iconcolor} />
        </TouchableDiv>
      {(pendingActionType.type === 'send' || pendingActionType.type === 'sendSingle') && <div className="h-100 col-12 p-0 px-3 m-0 justify-content-center align-items-center position-relative text-center">
        
         <div className={cn('fs_18 h-10 py-3' )} style={{fontWeight: '500'}}>Please select where following items  should be routed to </div>

           <div className="col-12 px-0 m-0 mt-1 row h-85">
           <div className='col-8 pt-2 pr-4 h-100 fs_14 fw-600' >
             <div className='col-12 px-0 h-100 fs_14 fw-600 px-0 ' style={{border: serverAppTheme?.gameCard_table_border}}>
             <div className="col-12 row text-left m-0 p-0 py-2 overflowY" style={{height:'2.5rem', borderBottom: serverAppTheme?.gameCard_table_border}}>
               <div className='col-7 px-2 text-left'>{pendingActionType?.data?.selectedItem[0]?.menuItemName}</div>
               <div className='col-2 px-2 text-left'>{pendingActionType?.data?.selectedItem[0]?.quantity}</div>
               <div className='col-3 px-2 text-center'>{pendingActionType?.data?.selectedItem[0]?.price}</div>
             </div>
             </div>
           </div>
             <div className='col-4 h-100 pr-0 px-0 overflowY'>
              <div className={cn('h-100', styles.center)}>
             {auth.orderTypes.map((element) => {
               if (element?.printRouting === true) {
                 return <div className='w-100'> <button className={cn('col-12 mb-2 w-100 text-center btn-ripple btn44 col-md-12 text-center fs_24',styles.secondaryBtn)} style={{background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color}} onClick={() => { onClose('yes',  [], element.id)}}>
                 {element.name}
               </button>
               </div>
               }
             })}
             </div>
             </div>
           </div>
       </div>}
    {(pendingActionType.type === 'send all' || pendingActionType.type === 'sendAll') && 
      <div className="h-100 col-12 p-0 px-3 m-0 justify-content-center align-items-center position-relative text-center ">
          <div className={cn('fs_18 h-10 py-3',)} style={{fontWeight: '500'}}>Please select where following items  should be routed to </div>

          <div className="col-12 p-0 m-0 mt-1 row h-85">
          <div className='col-8 h-100 pt-2 fs_14 pr-4 px-0 '>
            <div className={cn("col-12 rounded text-left h-100 m-0 fw-600 p-0 overflowY")}  style={{border: serverAppTheme?.gameCard_table_border}}>
              {selectedSeats.map((element) => {
                return <div className='col-12 row m-0 p-0 py-1 align-items-center'
                  key={element.menuItemId || index}
                style={{height:'2.5rem', borderBottom: serverAppTheme?.gameCard_table_border}}>
                  <div className='col-7 px-2 text-left'>{element.menuItemName}</div>
                  <div className='col-2 px-2 text-left'>{element.quantity}</div>
                  <div className='col-3 px-2 text-center'>${element.price}</div>
                </div>
            })}
            </div>
          </div>

          <div className='col-4 h-100 pr-0 px-0 overflowY'>
          <div className={cn('h-100', styles.center)}>
          {auth?.orderTypes?.filter(type => type?.printRouting).map((element) => (
              <div key={element.id} className="w-100">
                <button
                  className={cn(
                    'col-12 mb-2 w-100 text-center btn-ripple btn44 col-md-12 text-center fs_24',
                    styles.secondaryBtn
                  )}
                  style={{
                    background: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  onClick={() => onClose('yes', [], element.id)}
                >
                  {element.name}
                </button>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
     }
     {(pendingActionType.type === 'send selected' || pendingActionType.type === 'sendSelect') && 
      <div className="h-100 col-12 p-0 px-3 m-0 justify-content-center align-items-center position-relative text-center">
         <div className={cn('fs_18 h-10 py-3')} style={{fontWeight: '500'}}>Please select where following items  should be routed to </div>

          <div className="col-12 p-0 m-0 mt-1 row h-85">


            <div className='col-8 h-100 pt-2 fs_14 fw-600 pr-4 px-0 '>
            <div className="col-12 rounded text-left h-100 m-0 p-0 overflowY" style={{border: serverAppTheme?.gameCard_table_border}}>
              {selectedSeats.map((element) => {
                return <div className='col-12 row m-0 p-0 py-1 align-items-center fw-600' style={{height:'2.5rem', borderBottom: serverAppTheme?.gameCard_table_border}}>
                  <div className='col-7 px-2 text-left'>{element.menuItemName}</div>
                  <div className='col-2 px-2 text-left'>{element.quantity}</div>
                  <div className='col-3 px-2 text-center'>${element.price}</div>
                </div>
            })}
            </div>
          </div>
          <div className='col-4 h-100 pr-0 px-0 overflowY'>
            <div className={cn('h-100', styles.center)}>
            {auth.orderTypes.map((element) => {
              if (element?.printRouting === true) {
                return <div className='w-100'> <button className={cn('col-12 mb-2 w-100 text-center btn-ripple btn44 col-md-12 text-center fs_24',styles.secondaryBtn)}  style={{background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color}} onClick={() => { onClose('yes',  [], element.id)}}>
                {element.name}
              </button>
              </div>
              }
            })}
            </div>
            </div>
          </div>
      </div>
      }
    </div>
  </FullWithModal>
</Suspense>
  );
};

// Redux Part
const mapStateToProps = ({ orders }) => ({
  allMenusHashTable: orders.allMenusHashTable
});

export default connect(
  mapStateToProps,
  null
)(ConfirmationPop);
